export default "__VITE_ASSET__DYff8OIj__"